export default "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?5dff34d5fed607519dcbc76eaf9fc5b9";